import { NavLink, Link, useNavigate } from "react-router-dom";
import { LogOut, ExternalLink, Tag, Building2, Inbox, Handshake, DownloadCloud } from "lucide-react";
import { Logo } from "./Logo";
import { clearToken } from "../lib/adminApi";

export const AdminHeader = () => {
  const nav = useNavigate();
  const tab = ({ isActive }) =>
    `inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition ${isActive ? "bg-navy text-white" : "text-navy/70 hover:bg-navy/5"}`;
  return (
    <header className="sticky top-0 z-40 border-b border-navy/10 bg-cream/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-5 py-4">
        <Link to="/admin/deals" data-testid="admin-logo-link" aria-label="Admin dashboard"><Logo /></Link>
        <nav className="flex items-center gap-1 rounded-full bg-white p-1 shadow-soft" data-testid="admin-tabs">
          <NavLink to="/admin/deals" data-testid="admin-tab-deals" className={tab}><Tag size={15} /> Deals</NavLink>
          <NavLink to="/admin/projects" data-testid="admin-tab-projects" className={tab}><Building2 size={15} /> Projects</NavLink>
          <NavLink to="/admin/import" data-testid="admin-tab-import" className={tab}><DownloadCloud size={15} /> Import</NavLink>
          <NavLink to="/admin/crm" data-testid="admin-tab-crm" className={tab}><Handshake size={15} /> CRM</NavLink>
          <NavLink to="/admin/leads" data-testid="admin-tab-leads" className={tab}><Inbox size={15} /> Leads</NavLink>
        </nav>
        <div className="flex items-center gap-3">
          <a href="/" target="_blank" rel="noreferrer" className="btn-ghost hidden sm:inline-flex"><ExternalLink size={15} /> View site</a>
          <button onClick={() => { clearToken(); nav("/admin"); }} data-testid="admin-logout"
            className="inline-flex items-center gap-2 rounded-full border border-navy/15 px-5 py-2.5 text-sm font-medium text-navy transition hover:bg-navy hover:text-white">
            <LogOut size={15} /> Logout
          </button>
        </div>
      </div>
    </header>
  );
};
